import { webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const type22Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch内側のデザイン輪郭
  ctx.beginPath()
  ctx.strokeStyle = '#282828'
  ctx.lineWidth = 0.8
  ctx.moveTo(577, 105) // 左上_右上
  ctx.quadraticCurveTo(540, 114, 540, 114) // 左上＿左下
  ctx.quadraticCurveTo(560, 117, 542, 156)
  ctx.quadraticCurveTo(529, 178, 517, 197)
  ctx.quadraticCurveTo(512, 210, 517, 228)
  ctx.quadraticCurveTo(517, 192, 548, 200)
  ctx.quadraticCurveTo(559, 202, 569, 210)
  ctx.quadraticCurveTo(574, 214, 570, 219)
  ctx.quadraticCurveTo(568, 224, 565, 226)
  ctx.quadraticCurveTo(557, 228, 553, 219)
  ctx.quadraticCurveTo(557, 234, 551, 257)
  ctx.quadraticCurveTo(555, 246, 569, 244)
  ctx.quadraticCurveTo(575, 218, 575, 218)
  ctx.quadraticCurveTo(577, 215, 590, 228)
  ctx.quadraticCurveTo(588, 240, 584, 247)
  ctx.quadraticCurveTo(577, 258, 571, 254)
  ctx.quadraticCurveTo(568, 283, 577, 303)
  ctx.quadraticCurveTo(573, 279, 594, 232)
  ctx.quadraticCurveTo(595, 228, 608, 242)
  ctx.quadraticCurveTo(620, 250, 618, 268)
  ctx.quadraticCurveTo(614, 285, 605, 305)
  ctx.quadraticCurveTo(592, 330, 592, 330)
  ctx.quadraticCurveTo(578, 336, 563, 325)
  ctx.quadraticCurveTo(559, 315, 569, 309)
  ctx.quadraticCurveTo(557, 319, 536, 310)
  ctx.quadraticCurveTo(546, 326, 575, 345)
  ctx.quadraticCurveTo(575, 357, 575, 357) // 右下＿左

  ctx.moveTo(592, 355) // 右下＿右
  ctx.quadraticCurveTo(614, 280, 655, 295) // 左上＿右
  ctx.quadraticCurveTo(624, 265, 625, 230)
  ctx.quadraticCurveTo(624, 258, 598, 227)
  ctx.quadraticCurveTo(604, 218, 606, 219)
  ctx.quadraticCurveTo(603, 208, 605, 198)
  ctx.quadraticCurveTo(601, 209, 594, 212)
  ctx.quadraticCurveTo(598, 212, 595, 225)
  ctx.quadraticCurveTo(584, 219, 580, 211)
  ctx.quadraticCurveTo(585, 190, 596, 190)
  ctx.quadraticCurveTo(591, 175, 606, 174)
  ctx.quadraticCurveTo(591, 168, 588, 178)
  ctx.quadraticCurveTo(583, 185, 577, 208)
  ctx.quadraticCurveTo(532, 180, 566, 127)
  ctx.quadraticCurveTo(578, 110, 577, 105)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(577, 102) // 左上_右上
  ctx.quadraticCurveTo(540, 108, 535, 113) // 左上＿左下
  ctx.quadraticCurveTo(557, 120, 538, 156)
  ctx.quadraticCurveTo(529, 172, 513, 197)
  ctx.quadraticCurveTo(507, 218, 517, 235)
  ctx.quadraticCurveTo(522, 192, 548, 204)
  ctx.quadraticCurveTo(557, 205, 568, 213)
  ctx.quadraticCurveTo(566, 230, 549, 214)
  ctx.quadraticCurveTo(554, 234, 547, 265)
  ctx.quadraticCurveTo(555, 249, 572, 247)
  ctx.quadraticCurveTo(579, 220, 577, 222)
  ctx.quadraticCurveTo(590, 230, 585, 232)
  ctx.quadraticCurveTo(583, 255, 567, 251)
  ctx.quadraticCurveTo(564, 283, 579, 312)
  ctx.quadraticCurveTo(577, 282, 596, 236)
  ctx.quadraticCurveTo(620, 255, 613, 272)
  ctx.quadraticCurveTo(598, 320, 587, 327)
  ctx.quadraticCurveTo(578, 330, 566, 322)
  ctx.quadraticCurveTo(563, 318, 574, 302)
  ctx.quadraticCurveTo(557, 317, 530, 305)
  ctx.quadraticCurveTo(543, 333, 572, 348)
  ctx.quadraticCurveTo(572, 359, 572, 359) // 右下＿左

  ctx.moveTo(595, 352) // 右下＿右
  ctx.quadraticCurveTo(615, 284, 661, 298) // 左上＿右
  ctx.quadraticCurveTo(626, 266, 626, 218)
  ctx.quadraticCurveTo(621, 255, 602, 225)
  ctx.quadraticCurveTo(604, 222, 609, 219)
  ctx.quadraticCurveTo(606, 208, 606, 193)
  ctx.quadraticCurveTo(598, 207, 591, 212)
  ctx.quadraticCurveTo(595, 214, 592, 220)
  ctx.quadraticCurveTo(584, 215, 584, 209)
  ctx.quadraticCurveTo(589, 190, 599, 195)
  ctx.quadraticCurveTo(594, 177, 613, 175)
  ctx.quadraticCurveTo(591, 162, 584, 178)
  ctx.quadraticCurveTo(580, 185, 574, 202)
  ctx.quadraticCurveTo(537, 175, 570, 127)
  ctx.quadraticCurveTo(585, 105, 577, 102)

  // 外輪郭
  ctx.moveTo(554, 83) // 左上
  ctx.quadraticCurveTo(508, 163, 484, 253) // 左下
  ctx.quadraticCurveTo(520, 328, 569, 355) // 右下
  ctx.moveTo(594, 349) // 右下
  ctx.quadraticCurveTo(651, 308, 691, 275) // 右上

  // 内輪郭
  ctx.moveTo(557, 85) // 左上
  ctx.quadraticCurveTo(511, 163, 488, 251) // 左下
  ctx.quadraticCurveTo(520, 325, 572, 353) // 右下
  ctx.moveTo(597, 343) // 右下
  ctx.quadraticCurveTo(651, 304, 688, 273) // 右上
  ctx.quadraticCurveTo(658, 152, 557, 89) // 左上

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}
